import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { RootState } from "../../redux/store";
import { useSavedProperties } from "../../hooks/useSavedProperties";
import { monthlyRentPcm } from "../../util/propertyParsing";

const CompareTray: React.FC = () => {
  const { savedIds } = useSavedProperties();
  const properties = useSelector((state: RootState) => state.properties.items);
  const navigate = useNavigate();

  if (savedIds.length < 2) return null;

  const savedProperties = savedIds
    .map((id) => properties.find((p) => p.id === id))
    .filter((p): p is NonNullable<typeof p> => Boolean(p));

  if (savedProperties.length < 2) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[60] pointer-events-none lg:bottom-6">
      <div className="pointer-events-auto max-w-[1200px] mx-auto px-4 pb-4 lg:pb-0">
        <div className="bg-text-obsidian text-white shadow-[0_-8px_30px_rgba(0,0,0,0.2)] border border-solid border-white/10 rounded-none lg:rounded-lg overflow-hidden">
          <div className="px-4 py-3 border-b border-solid border-white/10 flex items-center justify-between gap-3">
            <span className="font-teko text-xl uppercase tracking-wider">
              Compare saved ({savedProperties.length})
            </span>
            <span className="font-manrope text-xs text-white/60 hidden sm:inline">
              Tap a property to view details
            </span>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-0 divide-y sm:divide-y-0 sm:divide-x divide-solid divide-white/10">
            {savedProperties.map((property) => {
              const pcm = monthlyRentPcm(
                property.price,
                property.rent_frequency
              );
              return (
                <button
                  key={property.id}
                  type="button"
                  onClick={() =>
                    navigate(`/services/rent/properties/${property.id}`)
                  }
                  className="text-left p-4 hover:bg-white/5 transition-colors"
                >
                  <div className="font-manrope text-sm text-white/80 truncate">
                    {property.display_address}
                  </div>
                  <div className="mt-2 flex flex-wrap gap-3 font-teko text-lg">
                    <span>{property.bedrooms ?? "—"} beds</span>
                    <span className="text-brand-yellow">
                      £{pcm.toLocaleString()} PCM
                    </span>
                  </div>
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompareTray;
